/* ga-creator-shop.js — creator direct-purchase pages.
   - Voltage radios (form= the product form) set the form's variant id and fire
     'change' on it, so assets/ga-voltage-gate.js locks/unlocks 220V exactly as on
     the product page. The gate's "Go back" re-checks the 110V radio and fires
     'change' on it, which lands here too.
   - Sticky bar appears once the hero Add to Cart scrolls out of view; its button
     clicks the real hero button, so product-form.js and the voltage gate apply. */
(function () {
  var root = document.querySelector('[data-gcs]');
  if (!root) return;

  var form = root.querySelector('form[data-type="add-to-cart-form"]');
  if (!form) return;
  var idInput = form.querySelector('input[name="id"]');
  var heroBtn = form.querySelector('[data-gcs-add]');
  // getAttribute: the form contains an input named "id", so form.id returns that input, not the form's id.
  var formId = form.getAttribute('id');
  var radios = Array.prototype.slice.call(document.querySelectorAll('input[type="radio"][form="' + formId + '"]'));
  var priceEl = root.querySelector('[data-gcs-price]');
  var sticky = root.querySelector('[data-gcs-sticky]');
  var stickyBtn = root.querySelector('[data-gcs-sticky-add]');
  var stickyPrice = root.querySelector('[data-gcs-sticky-price]');
  var stickyVolt = root.querySelector('[data-gcs-sticky-volt]');

  function sync(radio, fireChange) {
    if (!radio) return;
    var id = radio.getAttribute('data-variant-id');
    var price = radio.getAttribute('data-price');
    var available = radio.getAttribute('data-available') === 'true';
    if (idInput && String(idInput.value) !== String(id)) {
      idInput.value = id;
      if (fireChange) idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (priceEl && price) priceEl.textContent = price;
    if (stickyPrice && price) stickyPrice.textContent = price;
    if (stickyVolt) {
      var main = radio.closest('label') && radio.closest('label').querySelector('.gcs__vopt-main');
      if (main) stickyVolt.textContent = main.textContent;
    }
    if (heroBtn && heroBtn.getAttribute('aria-disabled') !== 'true') heroBtn.disabled = !available;
    if (stickyBtn) stickyBtn.disabled = !available;
  }

  radios.forEach(function (r) {
    r.addEventListener('change', function () { if (r.checked) sync(r, true); });
  });
  sync(radios.filter(function (r) { return r.checked; })[0], false);

  if (stickyBtn && heroBtn) {
    stickyBtn.addEventListener('click', function () { heroBtn.click(); });
  }

  if (sticky && heroBtn && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        // Visible whenever the hero Add to Cart is out of view (below the fold on
        // short phones, or after scrolling past it), hidden while it is on screen.
        sticky.hidden = e.isIntersecting;
      });
    }, { threshold: 0 });
    io.observe(heroBtn);
  }

  document.addEventListener('ga:creator-discount-applied', function (evt) {
    var offer = root.querySelector('[data-gcs-offer]');
    if (offer && evt.detail && root.getAttribute('data-code') &&
        evt.detail.code.toLowerCase() === root.getAttribute('data-code').toLowerCase()) {
      offer.classList.add('is-applied');
    }
  });
})();
